import { PkBox } from '@uefadigital/panenka-react';
import { lazy, memo, Suspense } from 'react';

import { useCoefficientsConfig } from '../../hooks/configuration';
import { useCoefficientsOptions } from '../../store';
import Footer from '../Footer';
import Table from '../Table';

import { useWindowSize } from '@hooks/useWindowSize';
import { CompetitionType } from '@shared-types/competition.types';

import * as styles from './styles.module.scss';

const Filters = lazy(() => import(/* webpackPrefetch: true */ '../Filters'));
const RankingsDropdown = lazy(() => import(/* webpackPrefetch: true */ '../Dropdowns/Rankings'));
const SeasonsDropdown = lazy(() => import(/* webpackPrefetch: true */ '../Dropdowns/Seasons'));

const Main = () => {
  const {
    configuration: { enableCalendar, competitionType },
  } = useCoefficientsConfig();
  const { options } = useCoefficientsOptions();
  const { isMobile } = useWindowSize();

  return (
    <>
      <PkBox className={styles.box} stroke={isMobile} rounded='xl' backgroundColor='elevation-01'>
        <div className={styles.navigationWrapper}>
          <Suspense>
            {options.coefficientsDropdown?.length > 1 && <RankingsDropdown />}
            {enableCalendar && <SeasonsDropdown />}
            {competitionType === CompetitionType.CLUB && <Filters />}
          </Suspense>
        </div>

        <Table />
      </PkBox>
      <Footer />
    </>
  );
};

export default memo(Main);
